<form ngForm #f="ngForm" class="flex flex-column w-full">
    <div class="mx-auto">
        <p-calendar name="value" [(ngModel)]="value" [showTime]="showTime" [hourFormat]="'12'" [inline]="true" [stepMinute]="stepMinute" [minDate]="minDate"></p-calendar>
    </div>

    <button type="button" class="btn-confirm ml-auto mt-3" [disabled]="f.invalid" (click)="save()">SAVE</button>
</form>